/**
 * Office.js React Context definition
 */
import { createContext } from 'react';

import { OfficeContextState } from '@/config/office/types';

// Create context with default values
export const OfficeContext = createContext<OfficeContextState>({
  error: null,
  host: null,
  isInitialized: false,
  isLoading: true,
  platform: null,
});
